import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from '@angular/core';
import {ZoneIconName} from "../../models";
import {NgClass} from "@angular/common";

@Component({
  selector: 'zone-icon',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './zone-icon.component.html',
  styleUrl: './zone-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZoneIconComponent implements OnInit, OnChanges {
    @Input({ required: true }) name: ZoneIconName | 'valve' | 'relay';
    @Input() size: number = 40;
    @Input() light: boolean = true;
    @Input() company?: string;
    fillClass: string = '';


    ngOnInit() {
        this.setColor();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['light']) {
            this.setColor();
        }
    }

    private setColor() {
        switch (this.company) {
            case 'klimor':
                this.fillClass = 'fill-klimor';
                return;
            case 'roth':
                this.fillClass = 'fill-roth';
                return;
            default:
                this.fillClass = this.light ? 'fill-light' : 'fill-dark';
        }
    }
}
